import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    // Initialization logic here
    console.log('Profile initialized');
  }
}
